/** Notlarım (113) tipleri — backend DTO'larıyla birebir. */

/**
 * Madde durumları — `REFERANS` (`TYPE='TODO_TASK_STATUS'`) kimlikleri.
 *
 * <p>Emsal: `features/actions/types.ts` → `ACTION_STATUS`. Kimlikler tek yerde durur; ekran ve
 * testlere çıplak 290/291 dağıtılırsa katalog genişlediğinde hangi sayının ne olduğu okunamaz.
 */
export const TODO_TASK_STATUS = {
  /** 290 — Aktif: madde tamamlanmadı (yeni madde bu durumda başlar). */
  ACTIVE: 290,
  /** 291 — Tamamlandı: madde "Tamamlananlar" bölümünde gösterilir. */
  COMPLETED: 291,
} as const

/** Notlarım listesi. */
export interface TodoList {
  id: number
  name: string
  ownerUserId: number
  /**
   * Liste sahibinin adı — **yalnız paylaşılan listelerde** dolu gelir. Kendi listelerinde sahip
   * gösterilmez; gereksiz bir ad "kendi listem / paylaşılan" ayrımını bulanıklaştırırdı.
   */
  ownerFullName: string | null
  /**
   * Liste isteği yapana mı ait? **Sunucudan gelir** — istemci `ownerUserId`'yi kendi kimliğiyle
   * karşılaştırmaz.
   *
   * **Bir YETKİ bayrağı DEĞİLDİR** (30.09.2026): yazma aksiyonları listeyi görebilen herkese
   * açıktır ve bu bayrağa bakmaz. Tek işi sahiplik gösterimi — paylaşılan listede
   * "Liste sahibi: …" satırı bununla çizilir.
   */
  owned: boolean
  taskCount: number
  completedTaskCount: number
  /**
   * Listeyi görebilen başka kişi sayısı — paylaş ikonunun rozeti. **Listeyi gören herkese doludur**
   * (30.09.2026); eskiden paylaşılan listelerde sunucu her zaman 0 dönerdi, çünkü paylaşılan
   * kullanıcı kiminle paylaşıldığını görmezdi. Paylaşımı yönetmek de ona açılınca o kural düştü.
   */
  shareCount: number
  /** Optimistic lock; güncellemede geri gönderilir. */
  modDate: string
}

/** Liste oluştur/güncelle yükü. `modDate` yalnız güncellemede gönderilir. */
export interface TodoListUpsert {
  name: string
  modDate?: string | null
}

/** Listedeki tek yapılacak iş maddesi. */
export interface TodoTask {
  id: number
  name: string
  /** {@link TODO_TASK_STATUS} — ekran maddeleri buna göre aktif/tamamlanan diye ikiye ayırır. */
  todoTaskStatusId: number
  modDate: string
  /**
   * 123 — maddenin aktif dosya eki sayısı. Ataç ikonunun üstündeki rozet ve ikonun vurgusu (`> 0`)
   * bundan okunur. Dosyaların kendisi yalnız pop-up açılınca ayrı uçtan çekilir.
   */
  attachmentCount: number
  /**
   * 124 — maddenin yorumu; `null` → yorum yok. Listedeki "Yorum" kolonu bunu tam metin gösterir.
   * Alan adı DB kolonunu (`DESCRIPTION`) izler, arayüz "Yorum" der.
   */
  description: string | null
}

/**
 * Notlarım madde dosyası (meta) — backend ortak `DocumentDto` ile birebir (123). İçerik burada yoktur:
 * indirme ve önizleme ortak ek ucundan (`/management/attachments/{id}`) kimlik-doğrulamalı çekilir.
 */
export interface TodoTaskDocument {
  id: number
  fileName: string
  size: number
  mimeType: string | null
  extension: string
  uploadedByName: string | null
  /** ISO zaman damgası (UTC). */
  uploadedAt: string
}

/** Madde ekle/metin düzenle yükü. */
export interface TodoTaskUpsert {
  name: string
  modDate?: string | null
  /**
   * 124 — sunucu yalnız EKLEMEDE okur; metin düzenleme ucu bu alanı yok sayar, yorum değişikliği kendi
   * ucundan yapılır. Şu an bunu gönderen ekran yok: "Not Ekle" pop-up'ındaki yorum alanı 19.10.2026'da
   * kaldırıldı. Alan sunucu sözleşmesini yansıttığı için tipte duruyor.
   */
  description?: string | null
}

/**
 * "Listeyi Görebilenler" satırı — paylaşım kaydı.
 *
 * <p>`userId` erişim **verilen** kişidir (paylaşımı yapan değil) ve erişim kaldırma bunun üzerinden
 * yapılır: kaldırmanın ölçütü kişidir, tek bir satır değil.
 */
export interface TodoShare {
  id: number
  userId: number
  fullName: string
  employeeId: string | null
}

/** Paylaşım pop-up'ındaki kişi seçicisinin tek seçeneği. Kaynak `USERS`, HR/SAP değil. */
export interface TodoShareUserOption {
  id: number
  name: string | null
  surname: string | null
  employeeId: string | null
}
